import Cookies from 'js-cookie'

const TokenKey = 'cp_admin_token'
const MessKey = 'cp_admin_mess'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function setUserInfo($info) {
    return Cookies.set(MessKey, $info)
}

export function getUserInfo() {
    return Cookies.get(MessKey)
}

export function removeToken() {
    Cookies.remove(MessKey)
    return Cookies.remove(TokenKey)
}
